// extracted by mini-css-extract-plugin
export default {"container":"WatchlistSelect_container__y-r3v","select":"WatchlistSelect_select__7jgCh"};